export const teamPersons: TableModule = {
    name: 'teamPersons',
    route: 'spa.organisations.teams.personLinks',
    defaultOrder: {
        column: 'type',
        direction: 'asc'
    },
    routeParams: [
        {
            param: 'organisation',
            prop: 'organisation_id'
        }, {
            param: 'team',
            prop: 'team_id'
        }
    ],
    columns: [
        {
            name: 'person_name',
            sortable: true,
            sortBy: 'person_firstname|person_lastname',
            mobile: true,
        },
        {
            name: 'type',
            sortable: true,
            mobile: true,
            breakpoint: 'md',
        },
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ['create', 'personLinks']
        }
    ]
}

